import { Alert, Checkbox } from "antd"
import { Button } from "components"
import { useEffect, useState } from "react"
import { InformationCircleIcon } from "@heroicons/react/24/outline"
import { AppOTPInput } from "components/inputs/AppOTPInput"
import { ILoginWith2FA } from "stores/auth"

export const VerifyOtp = ({
  verify2FA,
  isVerifying2FA,
  sendCode,
  isSendingCode,
}: {
  onSuccess?: () => void
  loginResponse: ILoginWith2FA
  verify2FA: (input: { code: string; generated: boolean }) => void
  isVerifying2FA: boolean
  sendCode: () => Promise<any>
  isSendingCode: boolean
}) => {
  const [otp, setOtp] = useState("")
  const [timer, setTimer] = useState<number>(0)
  const [sendToEmail, setSendToEmail] = useState<boolean>(false)
  const [canRequestNewCode, setCanRequestNewCode] = useState<boolean>(false)

  const disabled = !otp || otp.length < 6

  useEffect(() => {
    setTimer(30)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer > 0) return prevTimer - 1
        else return prevTimer
      })
    }, 1000)
    return () => clearInterval(interval)
    //eslint-disable-next-line
  }, [])

  const requestCode = async () => {
    const data = await sendCode()
    if (data?.success) {
      setCanRequestNewCode(true)
      setTimer(30)
    }
  }

  const handleVerifyCode = (code = otp) => {
    if (isVerifying2FA) return
    verify2FA({ code, generated: sendToEmail })
  }

  // Said on the button rather than as a spinner over the whole modal, which blurred the
  // very code the person had just typed.
  return (
    <>
      <div className="bg-white flex flex-col items-center justify-between gap-4 py-4 w-full px-6">
        <div className="flex flex-col items-center justify-between gap-4">
          <div className="text-[24px] font-[700]">
            Two Factor Authentication
          </div>
          <div className="text-[16px] font-[400]">
            Enter the 6-digit code from your authenticator app
          </div>
          <div className="w-full px-4">
            <AppOTPInput
              otp={otp}
              setOtp={setOtp}
              onComplete={handleVerifyCode}
              disabled={isVerifying2FA}
            />
          </div>

          <div className="mt-2">
            <div className="flex gap-1 items-center">
              <Checkbox
                checked={sendToEmail}
                onChange={(e) => {
                  setSendToEmail(e.target.checked)
                  if (e.target.checked) {
                    requestCode()
                  }
                }}
              />
              <div className="text-[15px] font-[400]">
                Send code to my mailbox.
              </div>
            </div>
          </div>
          {sendToEmail && (
            <Alert
              type="warning"
              showIcon
              message="Remember to uncheck this box if you regain access to your authenticator device."
              className="my-2"
              icon={<InformationCircleIcon className="w-4 h-4" />}
            />
          )}
          {sendToEmail && canRequestNewCode && (
            <div className="flex gap-2">
              <div>Didn't receive OTP?</div>
              <div
                className={`font-[600] ${
                  timer === 0
                    ? "cursor-pointer text-primary500 underline"
                    : "cursor-auto"
                }`}
                onClick={() => {
                  if (timer !== 0) return
                  requestCode()
                }}
              >
                {isSendingCode
                  ? "Resending ..."
                  : timer > 0
                  ? `Please wait ... (${timer})`
                  : "Resend"}
              </div>
            </div>
          )}

          <div className="mt-4">
            <Button
              color="primary"
              disabled={disabled || isVerifying2FA}
              onClick={() => {
                handleVerifyCode()
              }}
            >
              {isVerifying2FA ? "Verifying…" : "Verify code"}
            </Button>
          </div>
        </div>
        {/* <div className="cursor-pointer text-primary600 font-bold mt-3 text-left w-full">
          Return to sign in
        </div> */}
      </div>
    </>
  )
}
